import { render, staticRenderFns } from "./purorderview.vue?vue&type=template&id=2b2b8d9c&scoped=true&"
import script from "./purorderview.vue?vue&type=script&lang=js&"
export * from "./purorderview.vue?vue&type=script&lang=js&"
import style0 from "./purorderview.vue?vue&type=style&index=0&id=2b2b8d9c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2b8d9c",
  null
  
)

export default component.exports